import { BASE_URL } from "../../services/apiClient";

export const userHandler = {
  entityType: "user",

  getFieldValue: (field, selectedItem, userDetails) => {
    if (!selectedItem) return "";

    const userDetail = userDetails?.find(
      (detail) => detail.id === selectedItem.id
    );
    const mergedUser = { ...selectedItem, ...userDetail };

    switch (field.key) {
      case "firstName":
        return mergedUser.firstName || "";
      case "lastName":
        return mergedUser.lastName || "";
      case "phone":
        return mergedUser.workPhone || "";
      case "mobile":
        return mergedUser.cellularPhone || "";
      case "position":
        return mergedUser.position || "";
      case "title":
        return mergedUser.jobTitle || "";
      case "creationDate":
        return mergedUser.creationDate || "";
      case "resetPasswordRequired":
        return mergedUser.resetPasswordRequired ? "Yes" : "No";
      case "status":
        return mergedUser.active ? "Active" : "Inactive";
      case "password":
        return mergedUser.password || "";
      default:
        return mergedUser[field.key] || "";
    }
  },

  mapToApiFormat: (formData, selectedItem) => {
    // Preserve the original creation date if it exists, otherwise use current date
    const creationDate =
      formData.creationDate ||
      selectedItem?.creationDate ||
      new Date().toISOString();

    return {
      active: formData.status === "Active",
      name: formData.name,
      password: formData.password,
      email: formData.email,
      userInfo: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        workPhone: formData.phone,
        cellularPhone: formData.mobile,
        position: formData.position,
        jobTitle: formData.title,
      },
      creationDate: creationDate, // Always preserve or set in ISO format
      resetPasswordRequired: formData.resetPasswordRequired === "Yes",
    };
  },

  createApiDataForImmediate: (name) => {
    return {
      active: true,
      block: false,
      name: name,
      password: ".",
      email: ".",
      userInfo: {
        firstName: "",
        lastName: "",
        workPhone: "",
        cellularPhone: "",
        position: "",
        jobTitle: "",
        officeId: 0,
        officeName: "",
      },
      creationDate: new Date().toISOString(),
      isChecked: true,
      isEnabled: true,
      resetPasswordRequired: false,
    };
  },

  createLocalItemFromServer: (serverResponseId, name) => {
    const localItem = {
      id: serverResponseId,
      name: name,
      email: "",
      password: "",
      active: true,
      block: false,
      firstName: "",
      lastName: "",
      workPhone: "",
      cellularPhone: "",
      position: "",
      jobTitle: "",
      officeId: 0,
      officeName: "",
      creationDate: new Date().toISOString(),
      isChecked: true,
      isEnabled: true,
      resetPasswordRequired: false,
    };

    return localItem;
  },

  updateItems: (formData, itemId, { setUsers, setUserDetails }) => {
    // Update users array
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === itemId
          ? {
              ...user,
              name: formData.name || user.name,
              email: formData.email || user.email,
              password: formData.password || user.password,
              creationDate: formData.creationDate || user.creationDate,
              resetPasswordRequired:
                formData.resetPasswordRequired || user.resetPasswordRequired,
              active: formData.status === "Active",
            }
          : user
      )
    );

    // Update userDetails array
    setUserDetails((prevDetails) =>
      prevDetails.map((detail) =>
        detail.id === itemId
          ? {
              ...detail,
              firstName: formData.firstName || detail.firstName,
              lastName: formData.lastName || detail.lastName,
              workPhone: formData.phone || detail.workPhone,
              cellularPhone: formData.mobile || detail.cellularPhone,
              position: formData.position || detail.position,
              jobTitle: formData.title || detail.jobTitle,
            }
          : detail
      )
    );

    // Return updated item for immediate use
    return {
      id: itemId,
      name: formData.name,
      password: formData.password,
      email: formData.email,
      status: formData.status === "Active",
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
      mobile: formData.mobile,
      position: formData.position,
      title: formData.title,
      creationDate: formData.creationDate,
      resetPasswordRequired: formData.resetPasswordRequired === "Yes",
      active: formData.status === "Active",
    };
  },

  createUpdatedItem: (formData) => ({
    name: formData.name,
    email: formData.email,
    password: formData.password,
    active: formData.status === "Active",
    firstName: formData.firstName,
    lastName: formData.lastName,
    workPhone: formData.phone,
    cellularPhone: formData.mobile,
    position: formData.position,
    jobTitle: formData.title,
    creationDate: formData.creationDate,
    resetPasswordRequired: formData.resetPasswordRequired === "Yes",
  }),

  generateNewItemName: (existingItems) => {
    let counter = 1;
    let name;

    do {
      name = `New User${counter}`;
      counter++;
    } while (existingItems.some((item) => item.name === name));

    return name;
  },

  getAssignmentsURL: (itemId) => `${BASE_URL}/users/${itemId}/groups`,
  addAssignmentURL: (itemId, assignableId) =>
    `${BASE_URL}/Groups/${assignableId}/add-user/${itemId}`,
  removeAssignmentURL: (itemId, assignableId) =>
    `${BASE_URL}/Groups/${assignableId}/remove-user/${itemId}`,
  updateItemURL: (itemId) => `${BASE_URL}/Users/${itemId}`,
  deleteItemURL: (itemId) => `${BASE_URL}/Users/${itemId}`,
  createItemURL: () => `${BASE_URL}/Users`,
};
